import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CONNECTED_APPS_TABS } from '@/pages/settings/connected-apps/connected-apps-tab';
import { ConnectedAppsIndex } from '@/pages/settings/connected-apps/ConnectedAppsIndex';

const connectedAppsSearchSchema = z.object({
	tab: z.enum(CONNECTED_APPS_TABS).default('connections'),
});

export const Route = createFileRoute('/_authenticated/_app/settings/connected-apps')({
	component: ConnectedAppsIndex,
	validateSearch: connectedAppsSearchSchema,
});
